enum StatsDataUnit {
  DAY = "pD",
  HOUR = "pH",
  QUARTER = "pQ",
}

export default StatsDataUnit;